document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM is fully loaded!');
    document.getElementById('b2b-form-el').addEventListener('submit', async function (e) {
    e.preventDefault();

    // ── Clear previous errors ──────────────────────────────────────────
    document.querySelectorAll('.field-error').forEach(el => el.remove());
    document.querySelectorAll('.input-error').forEach(el => el.classList.remove('input-error'));

    // ── Grab values ───────────────────────────────────────────────────
    const fields = {
      business_name: document.querySelector('[name="contact[business_name]"]'),
      full_name:  document.querySelector('[name="contact[name]"]'),
      email:      document.querySelector('[name="contact[email]"]'),
      phone:      document.querySelector('[name="contact[phone]"]'),
      industry:    document.querySelector('[name="contact[industry]"]'),
      quantity:    document.querySelector('[name="contact[order_quantity]"]'),
      productType:    document.querySelector('[name="contact[product_type]"]'),
      body:       document.querySelector('[name="contact[body]"]'),
    };

    // ── Validation rules ──────────────────────────────────────────────
    const rules = [
      { field: 'business_name', label: 'Business Name',     required: true },
      { field: 'full_name',  label: 'Full Name',      required: true },
      { field: 'email',      label: 'Email Address',  required: true, type: 'email' },
      { field: 'phone',      label: 'Phone',          required: true },
      { field: 'industry',    label: 'Industry',        required: true },
      { field: 'quantity',    label: 'Quantity',        required: true },
      { field: 'productType',    label: 'Product Type',        required: true },
      { field: 'body',       label: 'Message',        required: true },
    ];

    let hasErrors = false;

    rules.forEach(({ field, label, required, type }) => {
      const el = fields[field];
      const val = el.value.trim();

      let error = null;

      if (required && !val) {
        error = `${label} is required.`;
      } else if (type === 'email' && val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        error = 'Please enter a valid email address.';
      }

      if (error) {
        hasErrors = true;
        el.classList.add('input-error');
        const msg = document.createElement('span');
        msg.className = 'field-error';
        msg.textContent = error;
        el.closest('.form-group').appendChild(msg);
      }
    });

    if (hasErrors) return;

    // ── Submit to n8n ─────────────────────────────────────────────────
    const submitBtn = this.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    const payload = {
      first_name: fields.business_name.value.trim(),
      last_name:  fields.full_name.value.trim(),
      email:      fields.email.value.trim(),
      phone:      fields.phone.value.trim(),
      industry:    fields.industry.value,
      quantity:    fields.quantity.value,
      productType:    fields.productType.value,
      message:    fields.body.value.trim(),
      submitted_at: new Date().toISOString(),
    };

    try {
        console.log(payload)
      const res = await fetch('https://n8n.awstreams.chat/webhook/fdb0b835-761d-47f8-9e7b-33b12f489eef', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        this.innerHTML = `
          <div style="text-align:center;padding:40px 20px;">
            <div style="font-size:2.5rem;margin-bottom:12px;">✅</div>
            <h3 style=" color:white;font-size:1.2rem;margin-bottom:8px;">Message Sent!</h3>
            <p style="color:white;font-size:0.9rem;">We'll get back to you as soon as possible.</p>
          </div>`;
      } else {
        throw new Error(`Server responded with ${res.status}`);
      }
    } catch (err) {
      console.error('Submission error:', err);
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;

      const errBanner = document.createElement('p');
      errBanner.className = 'field-error submit-error';
      errBanner.textContent = '⚠️ Something went wrong. Please try again.';
      this.appendChild(errBanner);
    }
  });
    
}); 
